import React, {useCallback, useContext, useEffect, useState} from 'react';
import {AuthContext} from 'contexts';
import {RootRoutes} from "enums";
import {Pager} from "pages/ProfileSearch/components/Pager";
import {blackListService, BlackListUser} from "services/blackListService";
import {ModerationPic} from "components/ModerationUserCard/ModerationPhotos/ModerationPic";
import {AddPhotosBlackListModal, AddToBlackListModal, DeleteBlackListUserButton} from "pages/BlackList/components";
import {toDateString} from "utils";
import {ProfileSearchByIDPageParams, ProfileSearchByIDPageParamsSources} from "pages/Profile";
import {AddPhotosBlackListUserButton} from "pages/BlackList/components/AddPhotosBlackListUserButton";


export const BlackListSearchPage = () => {
    const {env} = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [users, setUsers] = useState<BlackListUser[]>([]);

    const [isAddPhotosModalOpen, setIsAddPhotosModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState<BlackListUser | null>(null);

    const onNext = async () => {
        if (!env || isLoading) {
            return;
        }


        setCurrentPage(prev => prev + 1)
    };

    const onPrevious = () => {
        setCurrentPage(prev => prev - 1)
    }

    const reload = useCallback(async () => {
        if (!env) {
            return;
        }
        setIsLoading(true);
        const newUsers = await blackListService.getAll(env);
        newUsers && setUsers(newUsers);
        setIsLoading(false);
        setCurrentPage(0)
    }, [env]);

    const handleSearch = async () => {
        if (!env) {
            return;
        }
        reload()
    };

    const onClick = (id: string) => {
        window.open(`${RootRoutes.Profile}/${id}?${ProfileSearchByIDPageParams.Source}=${ProfileSearchByIDPageParamsSources.BlackList}`, '_blank', 'rel=noopener noreferrer')
    }

    const handleUserDeleted = (userId: string) => {
        setUsers(prevUsers => prevUsers.filter(user => user.userKey !== userId));
    };

    const handleAddPhotos = (user: BlackListUser) => {
        setSelectedUser(user);
        setIsAddPhotosModalOpen(true);
    };

    const handleAddPhotosModalClose = () => {
        setIsAddPhotosModalOpen(false);
        setSelectedUser(null);
    };


    useEffect(() => {
        if (!env) {
            return;
        }

        const timeout = setTimeout(reload, 300);
        setIsLoading(true);
        return () => clearTimeout(timeout);
    }, [env, reload]);


    return (
        <div className="d-flex flex-column align-items-center m-2 m-lg-3" style={{maxHeight: '90vh'}}>
            <AddToBlackListModal onSave={handleSearch}/>
            <AddPhotosBlackListModal
                isModalVisible={isAddPhotosModalOpen}
                setIsModalVisible={handleAddPhotosModalClose}
                selectedUser={selectedUser}
                onSave={handleSearch}
            />
            <div className="mt-3">
                {isLoading ? 'Загружается...' : !users.length && 'Результатов нет'}
            </div>
            {!!users.length && <>
                <div className="w-75 d-flex flex-row justify-content-end flex-rowsticky-top mt-2">
                    <Pager page={currentPage} hasMore={false} onNext={onNext} onPrevious={onPrevious}/>
                </div>
                <div className="overflow-auto w-100 d-flex flex-column align-items-center mt-2">
                    <div className="w-75">
                        <table className="table table-hover">
                            <thead className="bg-white border-bottom">
                            <tr>
                                <th scope="col">Имя</th>
                                <th scope="col">Фото</th>
                                <th scope="col">Дата создания</th>
                                <th scope="col">Найденных по лицу</th>
                                <th scope="col">Найденных по хешу</th>
                                <th scope="col">Действия</th>
                            </tr>
                            </thead>
                            <tbody>
                            {users.map(u => {
                                const photo = u.photos?.[0];
                                return (
                                    <tr key={u.userKey}>
                                        <td onClick={() => onClick(u.userKey)} style={{cursor: 'pointer'}}>
                                            <small>{u.name}</small></td>
                                        <td className="flex flex-column" style={{width: 120, cursor: 'pointer'}}
                                            onClick={() => onClick(u.userKey)}>
                                            {photo ?
                                                <div className="position-relative">
                                                    <ModerationPic
                                                        key={photo.key}
                                                        height={100}
                                                        userId={u.userKey}
                                                        pic={photo}
                                                        className={'rounded'}
                                                        objectFit={"cover"}
                                                        isInTable={true}/>
                                                    {u.photos && u.photos.length > 1 &&
                                                        <span className="badge bg-dark position-absolute"
                                                              style={{right: -5, top: -5}}>
                                                            +{u.photos.length - 1}
                                                        </span>}
                                                </div>
                                                : "Загружается..."}
                                        </td>
                                        <td onClick={() => onClick(u.userKey)}
                                            style={{cursor: 'pointer'}}>{u.createdDate && toDateString(u.createdDate)}</td>
                                        <td onClick={() => onClick(u.userKey)}
                                            style={{cursor: 'pointer'}}>{u.faceSimilarUserCount}</td>
                                        <td onClick={() => onClick(u.userKey)}
                                            style={{cursor: 'pointer'}}>{u.hashSimilarUserCount}</td>
                                        <td>
                                            <div className="d-flex" style={{gap: 10}}>
                                                <AddPhotosBlackListUserButton
                                                    user={u}
                                                    onAddPhotos={handleAddPhotos}
                                                />
                                                <DeleteBlackListUserButton
                                                    userId={u.userKey}
                                                    userName={u.name}
                                                    photoUrl={u.photos?.[0]?.image?.[0]?.link}
                                                    onUserDeleted={handleUserDeleted}
                                                />
                                            </div>
                                        </td>
                                    </tr>)
                            })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>}
        </div>
    );
};
